import { useEffect } from 'preact/hooks'

/**
 * Stop the page behind an open sheet from scrolling (D-104 §2).
 *
 * **The position is saved and restored rather than only `overflow: hidden`.**
 * iOS Safari keeps scrolling the body under a fixed overlay when overflow alone
 * is used, and the fix — pinning the body with `position: fixed` — resets the
 * scroll offset to the top when it is released. A user who opened an explanation
 * halfway down My Plan would be returned to the top of it.
 *
 * **Reference-counted**, because two sheets can briefly overlap during a close
 * animation and the second release must not unlock a page the first still owns.
 */
let locks = 0
let savedScrollY = 0

export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return

    if (locks === 0) {
      savedScrollY = window.scrollY
      const { body } = document
      body.style.position = 'fixed'
      body.style.top = `-${savedScrollY}px`
      body.style.left = '0'
      body.style.right = '0'
      body.style.overflow = 'hidden'
    }
    locks += 1

    return () => {
      locks -= 1
      if (locks > 0) return

      const { body } = document
      body.style.position = ''
      body.style.top = ''
      body.style.left = ''
      body.style.right = ''
      body.style.overflow = ''
      window.scrollTo(0, savedScrollY)
    }
  }, [active])
}
